
// import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';

const Notes = ({ item, setItem, isGroupNote, activeAccordion }) => {
  // const { handleSetAnswer } = useNewItemChange(setItem, 'Viewer', activeAccordion);

  return (
    // <div className='px-2 '>
    //   <p className='text font-m ar-light-color fs-13 pb-3px'>{item.content}</p>
    //   <div className="input w-25">
    //     <textarea
    //       className="form-control"
    //       rows={3}
    //       value={item.answer}
    //       onChange={(e) => handleSetAnswer(e, item)}
    //     />
    //   </div>
    // </div>
    <div className="d-flex px-2">
      <p className="col-md-6 text fs-12 font-m ar-light-color">
        {/* {item.content} */}
        {item.IsRepeated === 'true' && item.IsGroupEncounter === 'true' && isGroupNote ? item.PatientName + ' - ' + item.content : item.content}
      </p>
      <p className="col-md-6 text">{item.answer}</p>
    </div>
  );
};

export default Notes